import { render, staticRenderFns } from "./welinkCode.vue?vue&type=template&id=28e5a73a&scoped=true"
import script from "./welinkCode.vue?vue&type=script&lang=js"
export * from "./welinkCode.vue?vue&type=script&lang=js"
import style0 from "./welinkCode.vue?vue&type=style&index=0&id=28e5a73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5a73a",
  null
  
)

export default component.exports